import xinput from './fields/input.vue'
import xtextarea from './fields/textarea.vue'
import xselect from './fields/select.vue'
import xdiv from './div.vue'
import xcheckbox from './fields/checkbox.vue'
import xradios from './fields/radios.vue'
import xlink from './fields/link.vue'
import xbutton from './fields/button.vue'
import xarcfolder from './fields/archive_folder.vue'
import xdepartment from './fields/select_department.vue'
import xmedicine from './fields/select_medicine.vue'

export default {
  xinput,
  xtextarea,
  xdiv,
  xcheckbox,
  xradios,
  xlink,
  xbutton,
  xselect,
  xarcfolder,
  xdepartment,
  xmedicine,
}
